import React from 'react';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

interface IOnlineStoreRightsAcProProps {
    productName?: 'AcPro' | 'Ultra';
}
const OnlineStoreRightsAcPro: React.FC<IOnlineStoreRightsAcProProps> = ({ productName = 'Ultra' }) => {
    const { t } = useLang('theProduct.OnlineStoreRightsAcPro');
    const { locale } = getLocal();

    const getItem1Ele = () => {
        if (productName === 'Ultra') {
            return (
                <div className="item1 item">
                    <div className="item-content">
                        <p className="item-desc">
                            <span className="gradient-text">{t('ultra_item1_desc_1')}</span>
                        </p>
                        <p className="item-desc gradient-text2">{t('ultra_item1_desc_2')}</p>
                    </div>
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1745909367414/Frame%20161269784.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1745909367414/Frame%20161269784.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1745909376710/Frame%201612706829.jpg"
                    ></EcoImg>
                </div>
            );
        }
        return (
            <div className="item1 item acpro">
                <div className="item-content">
                    <p className="item-desc">
                        <span className="gradient-text">{t('ac_item1_desc_1')}</span>
                    </p>
                    <p className="item-desc">{t('ac_item1_desc_2')}</p>
                </div>
                <EcoImg
                    className="item-img"
                    pc="https://websiteoss.ecoflow.com/upload/image/1745654087013/pc-steam-ultra-1.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1745654087013/pc-steam-ultra-1.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1745833483156/Frame%201612706829.jpg"
                ></EcoImg>
            </div>
        );
    };
    const ac_item3_desc_1 = productName === 'AcPro' && locale === 'fr' ? t('fr_item3_desc_1') : t('ac_item3_desc_1');
    return (
        <section
            className={`${styles.OnlineStoreRightsAcPro} GtmModuleData-section`}
            data-section-id="OnlineStoreRightsAcPro"
            data-section-title={t('ac_item2_desc_1')}
        >
            <div className="rights-container">
                {getItem1Ele()}
                <div className="item2 item">
                    <div className="item-content">
                        <p className="item-desc">
                            <span className="gradient-text">{t('ac_item2_desc_1')}</span>
                        </p>
                        <p className="item-desc">{t('ac_item2_desc_2')}</p>
                    </div>
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1745632722094/pc-steam-ac-2.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1745632722094/pc-steam-ac-2.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1745649449154/m-steam-ac-2.jpg"
                    ></EcoImg>
                </div>
                <div className="item3 item">
                    <div className="item-content">
                        <p className="item-desc">
                            <span className="gradient-text">{ac_item3_desc_1}</span>
                        </p>
                        <p className="item-desc">{t('ac_item3_desc_2')}</p>
                    </div>
                    <EcoImg
                        className="item-img"
                        pc={
                            locale === 'uk'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1762306530475/pc-3.png'
                                : 'https://websiteoss.ecoflow.com/upload/image/1745632723004/pc-steam-ac-3.jpg'
                        }
                        pad={
                            locale === 'uk'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1762306530475/pc-3.png'
                                : 'https://websiteoss.ecoflow.com/upload/image/1745632723004/pc-steam-ac-3.jpg'
                        }
                        h5={
                            locale === 'uk'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1762306530200/m-3.png'
                                : 'https://websiteoss.ecoflow.com/upload/image/1745649448910/m-steam-ac-3.jpg'
                        }
                    ></EcoImg>
                </div>
                <div className="item4 item">
                    <div className="item-content">
                        <p className="item-desc">
                            {t.rich('ac_item4_desc_1', {
                                text1: (str: string) => <span className="gradient-text">{str}</span>,
                            })}
                        </p>
                        <p className="item-desc"></p>
                    </div>
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1745740456093/pc-steam-ac-4.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1745740456093/pc-steam-ac-4.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1745740465359/m-steam-ac-4.jpg"
                    ></EcoImg>
                </div>
                <div className="item5 item">
                    <div className="item-content">
                        <p className="item-desc">
                            <span className="gradient-text">{t('ac_item5_desc_1')}</span>
                        </p>
                        <p className="item-desc">{t('ac_item5_desc_2')}</p>
                    </div>
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1745841003829/Frame%20161269795%20(1).jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1745841003829/Frame%20161269795%20(1).jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1745841011534/Frame%201612707561.jpg"
                    ></EcoImg>
                </div>
                <div className="item6 item">
                    <div className="item-content">
                        <p className="item-desc">
                            <span className="gradient-text">{t('ac_item6_desc_1')}</span>
                        </p>
                        <p className="item-desc ac-item6">{t('ac_item6_desc_2')}</p>
                    </div>
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1745632722459/pc-steam-ac-6.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1745632722459/pc-steam-ac-6.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1745649447887/m-steam-ac-6.jpg"
                    ></EcoImg>
                </div>
                <div className="item7 item">
                    <div className="item-content">
                        <p className="item-desc">
                            <span className="gradient-text">{t('ac_item7_desc_1')}</span>
                        </p>
                        <p className="item-desc">{t('ac_item7_desc_2')}</p>
                    </div>
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1745632722276/pc-steam-ac-7.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1745632722276/pc-steam-ac-7.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1745649448078/m-steam-ac-7.jpg"
                    ></EcoImg>
                </div>
                <div className="item8 item">
                    <div className="item-content">
                        <p className="item-desc">
                            {t('online_store_g_8')}
                            <span className="gradient-text">{t('ac_item8_desc_1')}</span>
                        </p>
                        <p className="item-desc"></p>
                    </div>
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1745632721903/pc-steam-ac-8.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1745632721903/pc-steam-ac-8.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1745649448461/m-steam-ac-8.jpg"
                    ></EcoImg>
                </div>
                <div className="item9 item">
                    <div className="item-content">
                        <div className="item-desc">
                            <span className="gradient-text">{t('ac_item9_desc_1')}</span>
                            <p className="item-desc">{t('ac_item9_desc_2')}</p>
                        </div>
                        {/* <p className="opacity-text">4 MPPT</p> */}
                    </div>
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1745632722641/pc-steam-ac-9.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1745632722641/pc-steam-ac-9.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1745649448703/m-steam-ac-9.jpg"
                    ></EcoImg>
                </div>
            </div>
            {productName === 'Ultra' && <div className="rights-tips">{t('rights_tips')}</div>}
        </section>
    );
};

export default OnlineStoreRightsAcPro;
